
import React from "react";
import UserProfileCard from "./UserProfileCard";
import { Button } from "@/components/ui/button";
import { Profile } from "@/hooks/dashboard/useUserProfilesData";
import { User } from "@supabase/supabase-js";

interface UserListProps {
  users: Profile[];
  followingMap: Record<string, boolean>;
  currentUser: User | null;
  onFollow: (userId: string) => void;
  onMessage: (userId: string, username: string | null) => void;
  onViewProfile: (userId: string) => void;
  onRefresh: () => void;
}

const UserList: React.FC<UserListProps> = ({ 
  users, 
  followingMap, 
  currentUser, 
  onFollow, 
  onMessage,
  onViewProfile,
  onRefresh 
}) => {
  return (
    <div className="space-y-4">
      {users.map((profile, index) => (
        <UserProfileCard
          key={profile.id}
          profile={profile}
          index={index}
          isFollowing={!!followingMap[profile.id]}
          currentUser={currentUser}
          onFollow={onFollow}
          onMessage={onMessage}
          onViewProfile={onViewProfile}
        />
      ))}
      <Button 
        variant="outline" 
        className="w-full"
        onClick={onRefresh}
      >
        Refresh User List
      </Button>
    </div>
  );
};

export default UserList;
